export const contentstackBlockGroups = [
  { name: 'Asset', value: 'asset' },
  { name: 'Banners', value: 'banners' },
  { name: 'Block', value: 'block' },
  { name: 'Card Blocks', value: 'card_blocks' },
  { name: 'Collections', value: 'collections' },
  { name: 'Context Boxes', value: 'context_boxes' },
  { name: 'Dividers', value: 'dividers' },
  { name: 'Educational', value: 'educational' },
  { name: 'Features', value: 'features' },
  { name: 'Heros', value: 'heros' },
  { name: 'Integrations', value: 'integrations' },
  { name: 'Page Divider', value: 'page_divider' },
  { name: 'Lists', value: 'lists' },
  { name: 'Media', value: 'media' },
  { name: 'Presentational', value: 'presentational' },
  { name: 'Reviews', value: 'reviews' },
  { name: 'Titles', value: 'titles' },
  { name: 'Customer Service', value: 'customer_service' },
  { name: 'Content Cards', value: 'content_cards' },
  { name: 'Page Titles', value: 'page_titles' },
  { name: 'Content Areas', value: 'content_areas' },
  { name: 'Specialty', value: 'specialty' },
];